import type { SVGProps } from "react";
// generated from Alert.svg — do not edit manually
// prettier-ignore
export default function Alert(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 12 8 V 12 M 12 14 V 16 M 22 12 C 22 17.5228 17.5228 22 12 22 C 6.4772 22 2 17.5228 2 12 C 2 6.4772 6.4772 2 12 2 C 17.5228 2 22 6.4772 22 12 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
